
import "@/styles/pages/backgroundEraser/index.css";
import registerFit from "@/components/fit";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            
new Vue({
  created($, apower) {
    registerFit($, apower);
    $(".share-vertical-hidebar").$on("click", function (e) {
      $(this).parent().toggleClass("collapsed");
    });

    var codeBg = $(".person").children(".code-bg");
    $(".person").hover(function () {
      let index = $(this).index();
      codeBg.removeClass("active");
      codeBg.eq(index).addClass("active");
    });

    var oUl = $(".sliders");
    var aLi = oUl.find("li");
    var len = aLi.length; // 图的个数
    var imgWidth = $(".repeat").width(); // 一张图的宽
    aLi.eq(0).clone().appendTo(oUl); // 第一个复制一份，添加到ul中
    oUl.css("width", (len + 1) * imgWidth); // 给ul设置宽度

    var count = 0; // 计数器
    var timer = null; // 定时器
    // 一打开就执行
    timer = setInterval(auto, 1800);
    // 滑上停止，滑离开启
    oUl
      .on("mouseenter", function () {
        clearInterval(timer);
      })
      .on("mouseleave", function () {
        timer = setInterval(auto, 1800);
      });

    function auto() {
      if (count >= len) {
        count = 0;
        oUl.css("left", 0);
      }
      count++;
      oUl.stop().animate({
        left: -imgWidth * count,
      });
    }

    // 页面滚动增加对应的动态效果class

    let flag = true;
    $(".share-vertical-hidebar").click(function () {
      if (flag) {
        $(".right-options").addClass("active");
        flag = false;
      } else {
        $(".right-options").removeClass("active");
        flag = true;
      }
    });
    if (
      apower.lang === "en" ||
      apower.lang === "fr" ||
      apower.lang === "es" ||
      apower.lang === "pt" ||
      apower.lang === "de" ||
      apower.lang === "ja" ||
      apower.lang === "tw"
    ) {
      $(".right-options").css("display", "flex");
    }

    $(window).scroll(function () {
      let bHeight = document.body.clientHeight;
      let toTop = $(document).scrollTop();
      if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        // pc 端才显示右侧分享栏
        if (
          apower.lang === "en" ||
          apower.lang === "fr" ||
          apower.lang === "es" ||
          apower.lang === "pt" ||
          apower.lang === "de" ||
          apower.lang === "ja" ||
          apower.lang === "tw"
        ) {
          if (toTop < 700) {
            $(".right-options").css("display", "flex");
            $(".right-options").removeClass("active");
          } else {
            // $('.right-options').css('display', 'none');
            $(".right-options").addClass("active");
          }
        } else {
          if (toTop > 700) {
            $(".right-options").css("display", "flex");
            $(".right-options").removeClass("active");
          } else {
            // $('.right-options').css('display', 'none');
            $(".right-options").addClass("active");
          }
        }
      }
    });
  },
});

          })
        